// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a3e7d822","633":"05b40f3b","817":"0642af65"}[chunkId] + ".chunk.js";
};